import { cx } from "emotion";
import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import styles from "./TitleRelationshipFilterFooter.module.scss";

type TitleRelationshipFooterProps = {
  buttons: { name: string; onClick?: (event: React.MouseEvent<HTMLElement>) => void }[];
};

export const TitleRelationshipFooter = React.forwardRef<
  HTMLDivElement,
  TitleRelationshipFooterProps & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>(({ buttons, className, ...props }, ref) => (
  <div {...props} ref={ref} className={cx(styles.footer, className)}>
    {buttons.map(x => (
      <span key={x.name} onClick={x.onClick}>
        {x.name}
      </span>
    ))}
  </div>
));
